import _ from 'lodash';
import formatNumber from '@cores/utils/formatNumber';
export const name = 'PV.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const cellValue = _.get(row, prop);
    const innerHTML = cellValue ? `$${formatNumber(cellValue)}` : '-';
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {/* @ts-ignore */}
            <span domProps={{ innerHTML }}></span>
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const cellValue = row[column.property];
    return cellValue ? `$${formatNumber(cellValue)}` : '';
}
export default {
    renderDefault,
    exportMethod,
};
